import { useServices } from "./useServices.js";
const useFilesService = ()=>useServices().filesService;
export { useFilesService };
